var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { alarmCausesApi, } from "@api/enpoints/alarm-causes-api";
export const getAllAlarmCauses = createAsyncThunk("alarmCauses/getAll", (query_1, _a) => __awaiter(void 0, [query_1, _a], void 0, function* (query, { rejectWithValue }) {
    var _b, _c;
    try {
        const response = yield alarmCausesApi.getAllAlarmCauses(query);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to fetch alarm causes");
    }
    catch (error) {
        return rejectWithValue(((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            "Error fetching alarm causes");
    }
}));
export const getAlarmCauseById = createAsyncThunk("alarmCauses/getById", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c, _d, _e, _f;
    try {
        const response = yield alarmCausesApi.getAlarmCauseById(id);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to fetch alarm cause");
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            ((_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
            "Error fetching alarm cause");
    }
}));
export const createAlarmCause = createAsyncThunk("alarmCauses/create", (data_1, _a) => __awaiter(void 0, [data_1, _a], void 0, function* (data, { rejectWithValue }) {
    var _b, _c, _d, _e, _f;
    try {
        const response = yield alarmCausesApi.createAlarmCause(data);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to create alarm cause");
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            ((_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
            "Error creating alarm cause");
    }
}));
export const updateAlarmCause = createAsyncThunk("alarmCauses/update", (data_1, _a) => __awaiter(void 0, [data_1, _a], void 0, function* (data, { rejectWithValue }) {
    var _b, _c, _d, _e, _f;
    try {
        const response = yield alarmCausesApi.updateAlarmCause(data);
        if (response.data.isSuccess && response.data.data) {
            return response.data.data;
        }
        return rejectWithValue(response.data.message || "Failed to update alarm cause");
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            ((_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
            "Error updating alarm cause");
    }
}));
export const deleteAlarmCause = createAsyncThunk("alarmCauses/delete", (id_1, _a) => __awaiter(void 0, [id_1, _a], void 0, function* (id, { rejectWithValue }) {
    var _b, _c, _d, _e, _f;
    try {
        const response = yield alarmCausesApi.deleteAlarmCause(id);
        if (response.data.isSuccess) {
            return id;
        }
        return rejectWithValue(response.data.message || "Failed to delete alarm cause");
    }
    catch (error) {
        return rejectWithValue(((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) ||
            ((_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
            "Error deleting alarm cause");
    }
}));
